import { render, staticRenderFns } from "./OptionExcludedIcon.vue?vue&type=template&id=996ce6fa&scoped=true"
import script from "./OptionExcludedIcon.vue?vue&type=script&lang=js"
export * from "./OptionExcludedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996ce6fa",
  null
  
)

export default component.exports